var _excluded = ["event"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var gaEvent = function gaEvent(eventCategory) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref$event = _ref.event,
    event = _ref$event === void 0 ? 'GAevent' : _ref$event,
    payload = _objectWithoutProperties(_ref, _excluded);
  return (eventAction, eventLabel) => ({
    googleAnalytics: _objectSpread({
      event,
      eventCategory,
      eventAction,
      eventLabel
    }, payload)
  });
};
export var interaction = gaEvent('Interaction');
export var downloads = gaEvent('Downloads');
export var conversion = gaEvent('Conversion');
export var membership = gaEvent('Membership');
export var social = gaEvent('Social');
export var typeahead = gaEvent('TypeaheadSearch');
export var sponsorship = gaEvent('Sponsorship');
export var virtualPageView = payload => ({
  googleAnalytics: _objectSpread({
    event: 'GAvirtualpageview'
  }, payload)
});
export var outboundLinkEvent = eventAction => ({
  googleAnalytics: {
    event: 'Outboundlink',
    eventAction
  }
});